import { render } from "./FormInputCombobox.vue?vue&type=template&id=b64c50e2"
import script from "./FormInputCombobox.vue?vue&type=script&lang=js"
export * from "./FormInputCombobox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__